import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { register } from "./swRegister";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Register service worker for PWA offline support
register();
